<template>
  <div class="md-list-tile-title">
    <slot></slot>
  </div>
</template>

<script>
export default {
    name: "BsListTileTitle"
}
</script>

<style scoped>

</style>
